import { render } from "./DatePartsSelect.vue?vue&type=template&id=a8dd1c4e"
import script from "./DatePartsSelect.vue?vue&type=script&lang=js"
export * from "./DatePartsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__